import React from "react";

const Myoption = function(props) {
  const handelchoose = () => {
    props.handelChoose(props.name);
  };
  return (
    <div
      onClick={handelchoose}
      className={(props.isLast ? "last-option shadow-3 " : "my-option shadow-2 ") + props.classes}
      name={props.name}
    >
      <span className="otpion-text">{props.value}</span>
    </div>
  );
};
export default Myoption;
